import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ModelNavigation from './ModelNavigation';
import typography from '../../styles/typography.module.css';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';

function useHover() {
    const [hovering, setHovering] = useState(false);
    const onHoverProps = {
        onMouseEnter: () => setHovering(true),
        onMouseLeave: () => setHovering(false)
    };
    return [hovering, onHoverProps];
}

export const NameAndPrice = ({ currentModel, price, width }) => {
    const [openNav, setOpenNav] = useState(false);
    const [buttonAIsHovering, buttonAHoverProps] = useHover();
    const shopifyCIEMList = useSelector((state) => state.shopifyReducer.ciems);
    const { t } = useTranslation();
    let nav;
    if (openNav === false) {
        nav = <></>;
    } else {
        nav = (
            <ModelNavigation
                openNav={openNav}
                setOpenNav={setOpenNav}
                currentModel={currentModel}
            />
        );
    }

    return (
        <Box item className={layout.containerNamePrice}>
            {width > 800 ? (
                <Button
                    disableRipple={true}
                    className={buttons.btnModelPicker}
                    onClick={() => {
                        const header = document.getElementsByClassName('site-header  logo--left ');
                        if (openNav === false) {
                            if (header.length > 0) {
                                header[0].style.zIndex = 999;
                            }
                        } else {
                            if (header.length > 0) {
                                header[0].style.zIndex = 1001;
                            }
                        }
                        setOpenNav(!openNav);
                    }}>
                    <span className={typography.iemPrice} {...buttonAHoverProps}>
                        {buttonAIsHovering
                            ? t('model.choose_model')
                            : `${currentModel.name} - ${
                                  shopifyCIEMList.length > 0 ? shopifyCIEMList[0].currency : '$'
                              }${parseFloat(price.total).toFixed(2)}`}
                    </span>
                </Button>
            ) : (
                <span style={{ fontSize: '2.1rem', fontWeight: '300', color: 'black' }}>
                    {`${currentModel.name} - $${price.total}`}
                </span>
            )}
            {nav}
        </Box>
    );
};
